import { IChallenges, ISubChallengeDTO } from "adapters/challenges.adapter";
export const isSubChallengesCompleted = (challenges: IChallenges[], idx: number) => {
	if (challenges[idx]?.subChallengeDTO.every(subChallenge => subChallenge.completed)) {
		return true;
	}
	return false;
} 

export function findCurrentChallenge(challenges: IChallenges[]): { challengeIndex: number, subChallengeIndex: number, challengeDTO: IChallenges, subChallengeDTO: ISubChallengeDTO } {
	let currentChallengeIndex = 0;
	let currentSubChallengeIndex = 0;
	let currentChallengeDTO = null;
	let currentSubChallengeDTO = null;

	for (let i = 0; i < challenges.length; i++) {
		const challenge = challenges[i];
		currentChallengeDTO = challenge;

		for (let j = 0; j < challenge.subChallengeDTO.length; j++) {
			const subChallenge = challenge.subChallengeDTO[j];
			currentSubChallengeDTO = subChallenge;

			if (!subChallenge.completed) {
				currentSubChallengeIndex = j;
				return { challengeIndex: i, subChallengeIndex: currentSubChallengeIndex, challengeDTO: currentChallengeDTO, subChallengeDTO: currentSubChallengeDTO };
			}
		}

		currentChallengeIndex = i;
	}

	return { challengeIndex: currentChallengeIndex, subChallengeIndex: currentSubChallengeIndex, challengeDTO: currentChallengeDTO!, subChallengeDTO: currentSubChallengeDTO! };
}